export default "__VITE_ASSET__CghdcxJ2__"